export const languageValidationParameter = 'description';
export const longDescriptionValidationParameter = 'longDescription';

export const maxDescriptionLength = 254;
export const maxLongDescriptionLength = 4000;

export const maxLengthOfEmailsInputValue = 4000;

export const scheduleCompanyReports = 11;

export enum AllowedFavouriteType {
  predefinedReportSearch = 1,
  reminderFavourite = 4,
  predefinedSearchParameter = 5
}

export enum SharedWithPerFavouriteType {
  predefinedReportSearch = 1,
  folder = 3,
  companyReportFolder = 9,
  dashboardFolder = 10
}

export enum FolderFavouriteType {
  savedReports = 3,
  savedCompanyReports = 9,
  savedDashboards = 10
}

export enum DisabledWarningType {
  folder = 3,
  companyReportFolder = 9,
  dashboardFolder = 10
}

export enum FavouriteFormIds {
  disabledId = 'disabled',
  language = 'language',
  owners = 'owners',
  primaryOwner = 'primaryOwner',
  reportType = 'reportType',
  favouriteType = 'favouriteType',
  parent = 'parent',
  emailSubscribers = 'emailSubscribers',
  userGroups = 'userGroups',
  users = 'users'
}

export const FavouriteForm = 'FavouriteForm';
